import ReactDOM from "react-dom";

interface PortalledContentProps {
  targetPortal?: string;
}

/**
 * Portal a React component to a specific DOM element.
 *
 * Useful for Modals, Tooltips, or content that needs to be rendered outside
 * the normal React tree.
 */
const PortalledContent: React.FC<
  React.PropsWithChildren<PortalledContentProps>
> = ({ targetPortal = "portal-root", children }) => {
  const modalPortal = document.getElementById(targetPortal);

  if (modalPortal) {
    return ReactDOM.createPortal(children, modalPortal);
  }

  return null;
};

export default PortalledContent;
